import { cx } from "./util";

/** Lowercase mono eyebrow / tag / status. variant: comment (// x), bracket ([ x ]), badge, plain. */
export default function Label({ variant = "comment", active = false, live = false, className, children }) {
  const pre = variant === "comment" ? "// " : variant === "bracket" ? "[ " : "";
  const post = variant === "bracket" ? " ]" : "";
  return (
    <span className={cx("gd-label", variant === "badge" && "gd-label-badge", active && "gd-label-active", className)}>
      {live && <span className="gd-dot" aria-hidden="true" />}
      {pre}{children}{post}
    </span>
  );
}
